export default __webpack_public_path__ + "static/media/Hindi_af_2.02d16946.mp3";